<script >

import Loader from "../../../small_components/Loader.vue";
import GrayText from "../../../small_components/GrayText.vue";
import {axiosArticles} from "../../../../helpers/axios_requests";
import DefaultBox from "../../../slots/DefaultBox.vue";
import SmallTitle from "../../../small_components/SmallTitle.vue";
import RouterLinkTo from "../../../small_components/RouterLinkTo.vue";
import routes_mixin from "../../../../mixins/routes_mixin";

export default {
  mixins: [routes_mixin],
  name: "DashboardArticles",
  components: {
    RouterLinkTo,
    SmallTitle,
    DefaultBox,
    Loader,
    GrayText
  },
  computed: {
  },
  data() {
    return {
      loading: false,
      loaded: false,
      articles: [],
    }
  },
  mounted() {
    this.fetchArticles()
  },
  methods: {
    fetchArticles() {
      this.loading = true
      axiosArticles.getDashboardArticles().then(({data}) => {
        this.articles = data.articles || []
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    },
  }
}
</script>

<template>
  <div class="row">
    <div class="col-md-12 col-12">
      <default-box>
        <div class="d-flex align-items-center">
          <small-title
              class="flex-grow-1"
              no_margin
              :text="$t('dashboard.new_articles')"/>
          <img class="icon-30" src="/images/menu/articles.svg" alt="articles">
        </div>
        <hr/>
        <div class="d-flex align-items-center">
          <div class="user-upcoming-vacation">
            <div v-if="loaded && !articles.length">
              <gray-text>{{$t('articles.no_new_articles')}}</gray-text>
            </div>
            <div v-else>
              <ol>
                <li v-for="article in articles">
                  <router-link-to
                      v-if="article.article != null"
                      :route_name="route_names.article"
                      :route_params="{id: article.article?.id}">
                    {{ article.article?.title }}
                  </router-link-to>
                </li>
              </ol>
            </div>
            <loader v-if="loading"/>
          </div>
        </div>
      </default-box>
    </div>
  </div>
</template>

<style scoped>

</style>